import { type FC, useMemo, useState } from 'react'

import { useTranslation } from 'react-i18next'

import * as spriteIcons from 'assets/svg/sprite'
import DropDownSelect from 'features/DropdownSelectNew/DropDownSelect'
import { useUserProfile } from 'store'
import { useProfileCacheStore } from 'store/profileCacheStore'

import styles from './CategoriesDropdown.module.scss'

interface ICategoriesDropdown {
  selectedCategoryId: string
  onSelectCategory: (categoryId: string) => void
  username: string // required for looking up profile
}

const CategoriesDropdown: FC<ICategoriesDropdown> = ({
  selectedCategoryId,
  onSelectCategory,
  username
}) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  const viewer = useUserProfile()
  const viewerId = viewer?.id ?? ''

  const profile = useProfileCacheStore(state =>
    username ? state.getProfile(username, viewerId) : undefined
  )

  const options = useMemo(() => {
    const allOption = {
      value: '',
      label: t('allCategories')
    }

    const userCategories =
      profile?.all_media_categories?.map(cat => ({
        value: String(cat.id),
        label: cat.name
      })) ?? []

    return [allOption, ...userCategories]
  }, [profile?.all_media_categories, t])

  return (
    <DropDownSelect
      customClass={styles.categoriesDropdown}
      notSearchable
      icon={
        <div className='analytics-dropdown-icon'>
          <spriteIcons.IconHamburgerLinesWhite />
        </div>
      }
      placeholder={t('allCategories')}
      options={options}
      search={search}
      setSearch={setSearch}
      selectedOption={selectedCategoryId}
      setSelectedOption={onSelectCategory}
    />
  )
}

export default CategoriesDropdown
